/*solo para que no de error la carpeta plguins*/


// WEBPACK FOOTER //
// ./scripts/autoload/plugins/index.js